
<div class="sticky-menu-position-holder" 
	#stickyMenuPositionHolder
	[style.height.px]="isSticky ? anchorOptions.height : 0"
	[style.display]="isMobile && anchorOptions.hideMobile ? 'none' : 'block'"
	></div>
<div class="container-fluid bg-white"
	[class.sticky]="isSticky"
	[style.display]="isMobile && anchorOptions.hideMobile ? 'none' : 'block'"
	#stickyMenu
	>
	<div class="container px-0">
		<div class="d-md-flex anchor-tabs">

			<div *ngFor="let anchor of anchorTabs" 
				class="tab "
				[class.active]="activeAnchorTab == anchor.id"
				[style.color]="activeAnchorTab == anchor.id ? anchorOptions.colorActive : anchorOptions.color"
				(click)="scrollTo(anchor.id)"
				>{{anchor.name}}</div>

		</div>
	</div>
</div>
